<template>
  <BasicLayout>
    <template #wrapper>

      <upgradeStat />

      <el-card class="box-card">

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>通过率分布</span>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in tab" :key="index" :label="item.label" :name="item.value">
            <el-table
              :data="tableData"
              border
              style="width: 100%;"
            >
              <el-table-column
                prop="Title"
                label="关卡"
                align="center"
              >
                <template v-slot:default="scope">
                  {{ scope.row.Level }} - {{ scope.row.Title }}
                </template>
              </el-table-column>
              <el-table-column
                prop="LevelAfter"
                label="完成人数"
                align="center"
              />
              <el-table-column
                prop="LevelBefore"
                label="停留人数"
                align="center"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    width="370"
                    trigger="hover"
                    content="停留人数=当日到达这关人数+活跃到这关人数(去重)"
                  >
                    <span slot="reference">停留人数 <i class="el-icon-warning-outline" /></span>
                  </el-popover>
                </template>
                <template v-slot:default="scope">{{ scope.row.LevelBefore }}</template>
              </el-table-column>
              <el-table-column
                prop="Num"
                label="总人数"
                align="center"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    width="260"
                    trigger="hover"
                    content="总人数=停留人数+完成人数"
                  >
                    <span slot="reference">总人数 <i class="el-icon-warning-outline" /></span>
                  </el-popover>
                </template>
                <template v-slot:default="scope">{{ scope.row.Num }}</template>
              </el-table-column>
              <el-table-column
                prop="FailRate"
                label="关卡流失率"
                align="center"
              >
                <template v-slot:default="scope">{{ scope.row.FailRate }}%</template>
              </el-table-column>
              <el-table-column
                prop="SuccessRate"
                label="关卡通过率"
                align="center"
              >
                <template v-slot:default="scope">{{ scope.row.SuccessRate }}%</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserUpLevelStat } from '@/api/user/user_info'
import upgradeStat from '@/views/config/up-level-stat/components/upgrade_stat.vue'
import { dateStrTodate, getLastDates, scientificFormat } from '@/utils'

export default {
  name: 'UpLevelCountStat',
  components: {
    upgradeStat
  },
  data() {
    return {
      tab: [
        { label: '昨天', value: 'first' },
        { label: '最近30天', value: 'second' },
        { label: '最近90天', value: 'third' }
      ],
      activeName: 'first',
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        level: 1
      },
      ridData: {},
      tableData: [],
      levelData: [],
      headerData: []
    }
  },
  created() {
    // if (!this.queryParams.startDate) {
    //   this.queryParams.startDate = getLastDates(7)
    // }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }

    this.getTables()
  },
  methods: {
    handleClick(tab, event) {
      this.queryParams.level = parseInt(tab.index) + 1
      this.getTables()
    },
    dateStrTodate,
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.endDate) {
        this.msgError('请选择日期')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      this.loading = true
      getUserUpLevelStat(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          const { data } = res.data
          const tableData = []

          for (const i in data) {
            const val = data[i]
            for (const k in val.data) {
              tableData.push(val.data[k])
            }
          }
          this.tableData = tableData
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
